import React, { FC } from "react";

import { ProjectDetailView } from "./ProjectDetailView";
import { ProjectListView } from "./ProjectListView";

/** `/projects` */
export const Projects: FC = () => <ProjectListView />;

/** `/projects/:id` */
export const ProjectDetails: FC = () => <ProjectDetailView />;
